<div class="captura-foto">
  <ng-container *ngIf="hasWebcam; else noWebcamDetectedTemplate">
    <div class="modal-body">
      <ng-container *ngIf="!biometriaAprovada; else biometriaAprovadaTemplate">
        <p class="text-center mb-24">
          Também precisamos de uma foto do rosto do cliente para o processo e
          formalização do contrato.
          <strong
            >Se o cliente não capturou a foto pelo link enviado, realize a
            captura pelo computador.</strong
          >
        </p>
      </ng-container>

      <div class="panel-content">
        <div [ngClass]="{ 'capture-selfie': isLojistaPiloto }">
          <webcam
            *ngIf="showWebcam"
            [width]="500"
            [trigger]="webcamTrigger"
            (imageCapture)="handleImageCapture($event)"
          ></webcam>
          <img
            *ngIf="!showWebcam && selfiePreview"
            [src]="selfiePreview"
            class="webcam-preview"
            alt="Foto Webcam"
          />

          <div *ngIf="isLojistaPiloto" class="capture-selfie_content">
            <div class="capture-selfie_content_dica" *ngIf="showWebcam">
              <span
                >Centralize o rosto do cliente no circulo abaixo e aperte o
                botão para tirar a foto</span
              >
            </div>
          </div>
        </div>

        <div *ngIf="isLojistaPiloto">
          <div
            *ngIf="hasErrorBiometriaAssessment"
            class="text-orange aviso-biometria"
          >
            <span class="fa fa-ban mr-5"></span>
            Essa foto não foi aprovada!
            <a class="text-orange underline ml-5" (click)="onClickSaibaMais()"
              >Saiba mais.</a
            >
          </div>
        </div>

        <div
          *ngIf="!isLojistaPiloto || (isLojistaPiloto && !biometriaAprovada)"
        >
          <div *ngIf="!showWebcam" class="btn-tirar-foto pt-0">
            
              <button *ngIf="!isLojistaPiloto" type="button" class="btn btn-full-orange btn-continuar" (click)="finalizar()">
                Ok, continuar
              </button>
            
            
            <app-btn-small
              color="blue"
              title="Trocar foto"
              (click)="onClickTirarOutraFoto()"
              [isDisabled]="!isEnabledFotoAndEnviar"
            >
              <span class="fa fa-camera mr-5"></span>
            </app-btn-small>
          </div>
        </div>
      </div>

      <ng-container *ngIf="showWebcam || (!showWebcam && !biometriaAprovada)">
        <a
          class="text-orange text-center text-underline"
          (click)="abrirModalDicaDeFoto()"
          >Confira algumas dicas para uma boa foto</a
        >

        <div *ngIf="showWebcam" class="centered mt-20">
          <button
            class="btn btn-full-orange mx-0"
            (click)="onClickTirarUmaFoto()"
            [disabled]="!isEnabledFotoAndEnviar"
          >
            Tirar uma foto
          </button>
        </div>

        <div class="centered mb-0 mt-30">
          <span class="icon warning icone-laranja"></span>
          <p class="text-left mb-0">
            <strong class="text-orange">Atenção:</strong> Se a foto do cliente
            não for capturada,
            <strong class="text-danger"
              >não será possível finalizar essa proposta!</strong
            >
          </p>
        </div>
      </ng-container>
    </div>

    <div
      class="modal-footer justify-content-center"
      *ngIf="!showWebcam && biometriaAprovada"
    >
      <button type="button" class="btn btn-full-orange" (click)="finalizar()">
        Ok, continuar
      </button>
    </div>
  </ng-container>
</div>

<ng-template #noWebcamDetectedTemplate>
  <div class="modal-body text-center">
    <span class="d-inline-block icon warning icone-laranja large-icon"></span>

    <h4 class="mb-20"><strong class="text-blue">ATENÇÃO!</strong></h4>

    <p class="mb-20">
      Parece que não é possível capturar a foto do rosto do cliente em seu
      dispositivo.
      <strong
        >Acesse o aplicativo mobile da Omni+ para realizar a captura da foto do
        cliente e finalizar a ficha.</strong
      >
    </p>

    <p class="mb-0">
      <strong class="text-danger"
        >Esta etapa é obrigatória e não será possível formalizar a proposta sem
        a autenticação do cliente. Caso não consiga realizar nenhuma das
        alternativas a proposta deve ser cancelada.</strong
      >
    </p>
  </div>

  <div class="modal-footer">
    <button
      type="button"
      class="btn btn-full-orange"
      (click)="abrirModalSobreAppOmniMais()"
    >
      Continuar no app Omni+
    </button>

    <button type="button" class="btn btn-border-orange" (click)="excluir()">
      Excluir Ficha
    </button>
  </div>
</ng-template>

<ng-template #biometriaAprovadaTemplate>
  <p class="text-center mb-24">
    <ng-container *ngIf="celularFoiValidado; else celularNaoValidadoTemplate">
      Tudo certo com a etapa de Autenticação do Cliente. A captura de foto do
      rosto do cliente foi <strong>realizada com sucesso</strong> e você pode
      <strong>continuar para as próximas etapas.</strong>
    </ng-container>
  </p>
</ng-template>

<ng-template #celularNaoValidadoTemplate>
  A captura de foto do rosto do cliente foi realizada com sucesso, mas
  <strong
    >parece que o cliente não realizou a validação do celular. Lembre-se que
    desta forma não será possível realizar a assinatura digital do
    contrato.</strong
  >
</ng-template>
